import api from './api';

const BASE_URL = '/support/api';

const supportDeskService = {
  // ── Dashboard ──────────────────────────────────────────────────────────────
  getDashboard: () => api.get(`${BASE_URL}/tickets/dashboard/`),

  // ── Tickets ────────────────────────────────────────────────────────────────
  getTickets: (params) => api.get(`${BASE_URL}/tickets/`, { params }),
  getTicket: (id) => api.get(`${BASE_URL}/tickets/${id}/`),
  createTicket: (data) => api.post(`${BASE_URL}/tickets/`, data),
  updateTicket: (id, data) => api.patch(`${BASE_URL}/tickets/${id}/`, data),

  // ── Ticket actions ─────────────────────────────────────────────────────────
  addMessage: (id, data) => api.post(`${BASE_URL}/tickets/${id}/add_message/`, data),
  assignTicket: (id, agentId) => api.post(`${BASE_URL}/tickets/${id}/assign/`, { agent_id: agentId }),
  rateTicket: (id, rating, feedback) => api.post(`${BASE_URL}/tickets/${id}/rate/`, { rating, feedback }),
  getMyTickets: () => api.get(`${BASE_URL}/tickets/my_tickets/`),
  getMyAssignedTickets: () => api.get(`${BASE_URL}/tickets/my_assigned_tickets/`),

  // ── Ticket messages ────────────────────────────────────────────────────────
  getMessages: (ticketId) => api.get(`${BASE_URL}/messages/`, { params: { ticket: ticketId } }),

  // ── Ticket attachments ─────────────────────────────────────────────────────
  getAttachments: (ticketId) => api.get(`${BASE_URL}/attachments/`, { params: { ticket: ticketId } }),
  uploadAttachment: (data) => api.post(`${BASE_URL}/attachments/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  // ── Ticket lookups ─────────────────────────────────────────────────────────
  getCategories: () => api.get(`${BASE_URL}/categories/`),
  getPriorities: () => api.get(`${BASE_URL}/priorities/`),
  getAgents: () => api.get(`${BASE_URL}/agents/`),

  // ── Knowledge Base ─────────────────────────────────────────────────────────
  getFeaturedArticles: () => api.get(`${BASE_URL}/kb/?featured=true`),
  getKnowledgeBase: (params) => api.get(`${BASE_URL}/kb/`, { params }),
  getAllArticles: (params) => api.get(`${BASE_URL}/kb/`, { params }),
  getArticle: (slug) => api.get(`${BASE_URL}/kb/${slug}/`),
  createArticle: (data) => api.post(`${BASE_URL}/kb/`, data),
  updateArticle: (slug, data) => api.patch(`${BASE_URL}/kb/${slug}/`, data),
  deleteArticle: (slug) => api.delete(`${BASE_URL}/kb/${slug}/`),
  searchKB: (query) => api.get(`${BASE_URL}/kb/search/`, { params: { q: query } }),
  markHelpful: (slug) => api.post(`${BASE_URL}/kb/${slug}/mark_helpful/`),
  markNotHelpful: (slug) => api.post(`${BASE_URL}/kb/${slug}/mark_not_helpful/`),

  // ── FAQs ───────────────────────────────────────────────────────────────────
  getFAQs: (params) => api.get(`${BASE_URL}/faq/`, { params }),
  getFAQ: (id) => api.get(`${BASE_URL}/faq/${id}/`),
  createFAQ: (data) => api.post(`${BASE_URL}/faq/`, data),
  updateFAQ: (id, data) => api.patch(`${BASE_URL}/faq/${id}/`, data),
  deleteFAQ: (id) => api.delete(`${BASE_URL}/faq/${id}/`),
  getFAQsByCategory: () => api.get(`${BASE_URL}/faq/by_category/`),
};

export default supportDeskService;
